import { z } from 'zod'

export const DEFAULT_OFFICE_HOURS = {
  afterHoursEnabled: true,
  startTime: '10:00',
  endTime: '20:00',
  timeZone: 'America/New_York',
  messageTemplate:
    'Thank you for your message. Our offices are currently closed, but we will contact you when we resume operations. For emergencies, please contact your emergency number.',
}

const timeSchema = z
  .string()
  .trim()
  .regex(/^(?:[01]\d|2[0-3]):[0-5]\d$/, 'Use a 24-hour time such as 09:00.')

const timeZoneSchema = z.string().trim().min(1, 'Select a timezone.')

export const officeHoursValuesSchema = z.object({
  afterHoursEnabled: z.boolean(),
  startTime: timeSchema,
  endTime: timeSchema,
  timeZone: timeZoneSchema,
  messageTemplate: z.string().trim().min(1, 'Enter an after-hours message.').max(10000),
})

export const officeHoursUpdateSchema = officeHoursValuesSchema.extend({
  buildingId: z.number().int().positive(),
})

export function getOfficeHoursValues(row, patch = {}) {
  return {
    afterHoursEnabled: row.afterHoursEnabled ?? false,
    startTime: normalizeTime(row.startTime) || DEFAULT_OFFICE_HOURS.startTime,
    endTime: normalizeTime(row.endTime) || DEFAULT_OFFICE_HOURS.endTime,
    timeZone: row.timeZone || DEFAULT_OFFICE_HOURS.timeZone,
    messageTemplate: row.messageTemplate || DEFAULT_OFFICE_HOURS.messageTemplate,
    ...patch,
  }
}

export function buildOfficeHoursUpdate(row, patch = {}) {
  return officeHoursUpdateSchema.safeParse({
    buildingId: Number(row.buildingId),
    ...getOfficeHoursValues(row, patch),
  })
}

export function normalizeTime(value) {
  if (typeof value !== 'string') return ''
  const match = value.match(/^(\d{2}:\d{2})/)
  return match?.[1] ?? ''
}
